import { createProvider } from '@nvision/services/data-provider';

import type { BranchFilters } from '../../models';
import * as api from './api';
import { normalizeBranches, normalizeBranchFilters } from './normalize';

export const fetchBranches = createProvider(
  (filters: Partial<BranchFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchBranches(normalizeBranchFilters(filters), { signal }),
).andThen((res) => normalizeBranches(res));
